import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useConfiguracion from "../hooks/useConfiguracion";
import { abrirPoliticas } from "../components/Shell/PoliticasUso";
import "../styles/SplashScreen.css";

const TEXTOS_CARGA = [
  "Iniciando sistema...",
  "Cargando módulos de seguridad...",
  "Conectando con servicios...",
  "Preparando interfaz...",
  "¡Listo para usar!",
];

/**
 * Pantalla de arranque (única ruta que se ve antes del mapa). Todo sale de
 * `Configuracion` (HU-005 marca blanca + HU-018): logo/imagen de inicio,
 * nombre de la entidad, mensaje, colores de fondo/texto, y si entra sola al
 * mapa o espera a que el ciudadano pulse "Continuar".
 */
const SplashScreen = () => {
  const navigate = useNavigate();
  const { configuracion } = useConfiguracion();
  const [progreso, setProgreso] = useState(0);
  const [textoActual, setTextoActual] = useState(TEXTOS_CARGA[0]);

  const auto = configuracion.inicio_auto !== false;
  const colorFondo = configuracion.inicio_color_fondo || '#14161A';
  const colorTexto = configuracion.inicio_color_texto || '#FFFFFF';
  // Imagen de fondo: solo si está activada Y hay una cargada.
  const fondoImagen = configuracion.inicio_fondo_imagen_activo && configuracion.inicio_fondo_imagen
    ? configuracion.inicio_fondo_imagen
    : null;
  // Forma del botón "Continuar" (HU-020).
  const radioBoton = { pill: '999px', rounded: '12px', square: '4px' }[configuracion.inicio_boton_forma] || '999px';

  const irAlMapa = () => navigate("/cifranegra", { replace: true });

  useEffect(() => {
    const intervaloProgreso = setInterval(() => {
      setProgreso((actual) => (actual >= 100 ? 100 : actual + 2));
    }, 80);

    const intervaloTexto = setInterval(() => {
      setTextoActual((actual) => {
        const indice = TEXTOS_CARGA.indexOf(actual);
        return TEXTOS_CARGA[(indice + 1) % TEXTOS_CARGA.length];
      });
    }, 1000);

    // Solo avanza sola si `inicio_auto` está activo (default). Si no, se
    // muestra un botón "Continuar" y la navegación la dispara el ciudadano.
    let temporizadorNavegacion;
    if (auto) {
      temporizadorNavegacion = setTimeout(() => navigate("/cifranegra", { replace: true }), 5000);
    }

    return () => {
      clearInterval(intervaloProgreso);
      clearInterval(intervaloTexto);
      clearTimeout(temporizadorNavegacion);
    };
  }, [navigate, auto]);

  return (
    <div className="splash-container" style={{ backgroundColor: colorFondo }}>
      {fondoImagen && (
        <img className="splash-fondo-img" src={fondoImagen} alt="" aria-hidden="true" />
      )}
      <div className="splash-content">
        {/* Con imagen de fondo activa se muestra solo el afiche (sin el
            logo/mensaje/features encima, que lo tapaban). Si además está
            apagado el ingreso automático, queda solo el botón "Continuar". */}
        {!fondoImagen && (
          <>
            {configuracion.inicio_imagen ? (
              <img className="splash-imagen" src={configuracion.inicio_imagen} alt={configuracion.nombre_entidad} />
            ) : (
              <div className="splash-logo">
                {configuracion.logo
                  ? <img src={configuracion.logo} alt={configuracion.nombre_entidad} />
                  : <span>{configuracion.nombre_entidad?.[0] || 'C'}</span>}
              </div>
            )}

            <h1 className="splash-title" style={{ color: colorTexto }}>{configuracion.nombre_entidad}</h1>
            <p className="splash-subtitle" style={{ color: colorTexto, opacity: 0.85 }}>
              {configuracion.inicio_mensaje || 'Reporta incidencias de tu zona en minutos'}
            </p>

            {configuracion.inicio_features_imagen ? (
              <img
                className="splash-features-imagen"
                src={configuracion.inicio_features_imagen}
                alt=""
              />
            ) : (
              <div className="splash-features">
                <div className="feature-item" style={{ color: colorTexto }}>
                  <div className="feature-icon"><i className="fas fa-shield-alt"></i></div>
                  <span className="feature-text" style={{ color: colorTexto }}>Seguro</span>
                </div>
                <div className="feature-item" style={{ color: colorTexto }}>
                  <div className="feature-icon"><i className="fas fa-bolt"></i></div>
                  <span className="feature-text" style={{ color: colorTexto }}>Rápido</span>
                </div>
                <div className="feature-item" style={{ color: colorTexto }}>
                  <div className="feature-icon"><i className="fas fa-users"></i></div>
                  <span className="feature-text" style={{ color: colorTexto }}>Confiable</span>
                </div>
              </div>
            )}

            {auto && (
              <div className="splash-animation">
                <div className="loading-bar-container">
                  <div className="loading-bar" style={{ width: `${progreso}%` }}></div>
                </div>
                <div className="loading-text" style={{ color: colorTexto }}>{textoActual}</div>
                <div className="progress-percentage" style={{ color: colorTexto }}>{progreso}%</div>
              </div>
            )}
          </>
        )}

        {!auto && (
          <button
            type="button"
            className={`splash-continuar${fondoImagen ? ' splash-continuar-flotante' : ''}`}
            style={{
              color: configuracion.inicio_boton_color_texto || colorTexto,
              borderRadius: radioBoton,
              ...(configuracion.inicio_boton_color
                ? { background: configuracion.inicio_boton_color, borderColor: configuracion.inicio_boton_color }
                : { borderColor: configuracion.inicio_boton_color_texto || colorTexto }),
            }}
            onClick={irAlMapa}
          >
            {configuracion.inicio_boton_texto || 'Continuar'}
          </button>
        )}

        <button
          type="button"
          className="splash-politicas"
          style={{ color: colorTexto }}
          onClick={abrirPoliticas}
        >
          Políticas de uso y tratamiento de datos
        </button>
      </div>
    </div>
  );
};

export default SplashScreen;
